/** @typedef {import('../types/models').Country} Country */

import { instance } from '../config/api';

/** @returns {Promise<{ label: string, value: number }[]>} */
const fetchCountries = async () => {
  const { data } = await instance.get('country');
  let countries = [];
  if (data.data) {
    data.data.forEach(({ name, id }) => {
      countries.push({
        label: name,
        value: id
      });
    });
    return countries;
  }
  return data;
};

export { fetchCountries };
